import Vue from 'vue';
import Products from '../vue/Products.vue';

if (document.getElementById('products')) {
    new Vue({
        el: '#products',
        components: {
            'products': Products
        }
    })
}

jQuery(document).ready(function ($) {

    $('.product__tabs-header .tab').click(function (e) {
        e.preventDefault();
        $('.product__tabs-header .tab').removeClass('tab--active');
        $(this).addClass('tab--active');
        $('.tab-content').removeClass('tab-content--active');
        $($(this).data("tab")).addClass('tab-content--active');
    });

    if ($('.product__tabs-content').length) {
        $('.tab-content').first().addClass('tab-content--active');
        $('.tab').first().addClass('tab--active');
    }

});